/**
 * Enumerator for all payment types
 * @export
 * @enum DayOfWeek
 */
export enum PaymentType {
    PayLater = 'PayLater',
    PaymentCard = 'PaymentCard'
  }
